import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import config from '../../../config';
import { dispatch } from '../../../events';
import { types } from '../../../events/loader';
import httpUtils from '../../../utils/http.utils';

const useStyles = makeStyles((theme) => ({
    inputComment: {
        width: '100%'
    }
}));

const AddComment = ({ objectType, objectId, parentCommentId, onAdd }) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [comment, setComment] = useState('');

    const onOpen = () => {
        setOpen(true);
    }

    const onClose = () => {
        setOpen(false);
        setComment('');
    }

    const addComment = async () => {
        if (!!comment) {
            dispatch(types.SET_LOADER);
            const response = await httpUtils.post(`${config.BACK_API}/api/${objectType}/${objectId}/comment`, {
                parentCommentId,
                text: comment
            });
            onClose();
            onAdd({ ...response.data, comments: { results: [] } });
            dispatch(types.UNSET_LOADER);
        }
    }

    return (
        <>
            <Button variant="contained" onClick={onOpen}>Add comment</Button>
            <Dialog
                open={open}
                fullWidth={true}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Add your comment"}</DialogTitle>
                <DialogContent>
                    <TextField
                        id="outlined-multiline-static"
                        className={classes.inputComment}
                        label="Comment"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        multiline
                        rows={15}
                        variant="outlined"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={addComment} color="primary" autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default AddComment;